import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/ic_monitor_new.png'
import _imports_1 from '../../assets/ic_monitor_switch.png'


const _hoisted_1 = {
  class: "row-box",
  style: {"align-items":"center"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"30px","height":"30px"}
}, null, -1)
const _hoisted_3 = {
  key: 0,
  src: _imports_1,
  style: {"width":"20px","height":"20px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createBlock(_component_van_list, {
    loading: _ctx.loading,
    "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loading) = $event)),
    finished: _ctx.finished,
    "finished-text": "没有更多了",
    onLoad: _ctx.onMoreLoad
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listData, (item) => {
        return (_openBlock(), _createBlock(_component_van_cell, {
          key: item.id,
          onClick: ($event: any) => (_ctx.onClickSelectItemEvent(item))
        }, {
          title: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _createElementVNode("p", {
                style: _normalizeStyle([{"flex":"1","margin-left":"10px","text-align":"start"}, item.id == _ctx.videoId?'color:#6A4DB9':'color:#333'])
              }, _toDisplayString(item.name), 5),
              (item.id == _ctx.videoId)
                ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 2
        }, 1032, ["onClick"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["loading", "finished", "onLoad"]))
}